export const ERP_READINESS = [
  { value: "all", label: "All readiness" },
  { value: "ready", label: "ERP ready" },
  { value: "not_ready", label: "Not ERP ready" },
];

export const SCOPE_OPTIONS = [
  { value: "mine", label: "My projects" },
  { value: "all", label: "All accessible" },
];

export const EMPTY_FILTERS = {
  pm_id: "all",
  customer: "all",
  brand: "all",
  status_filter: "all",
  phase: "all",
  erp_readiness: "all",
  date_from: "",
  date_to: "",
};

export const activeFilterCount = (filters) =>
  Object.entries(filters).filter(([k, v]) => (k === "date_from" || k === "date_to" ? !!v : v && v !== "all")).length;
